var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reMain" },
    [
      _c("RealTitle", {
        attrs: { titleInfo: _vm.titleInfo, backPath: _vm.backPath },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "reMainContent" }, [
        _c("div", { staticClass: "reNewsContent" }, [
          _c(
            "div",
            { staticClass: "newsMode fx bbs" },
            _vm._l(_vm.newTypeList, function (item, index) {
              return _c(
                "span",
                {
                  key: index,
                  class: [_vm.tabsActNum === index ? "spanAct" : ""],
                  on: {
                    click: function ($event) {
                      return _vm.tabs(index, item.id)
                    },
                  },
                },
                [_vm._v(_vm._s(item.newsTypeName))]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "newsList" },
            [
              _vm.reNewsInfo.length <= 0
                ? _c("div", { staticClass: "noNews" }, [_vm._v("暂无数据")])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.reNewsInfo, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    on: {
                      click: function ($event) {
                        return _vm.lookDetail(item.id, item.newsUrl)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "newsItemTitle" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.newsTitle) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "newsItemData" }, [
                      _c("i", { staticClass: "el-icon-date" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.createTime))]),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.page.pageNumber,
                  "page-sizes": [5, 10, 15, 20, 50],
                  "page-size": _vm.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }